import { isPermissioned } from '@src/model/user/permission';
import { useComment } from '@src/store/comments/hooks/useComment';
import type { FC } from 'react';
import ContentModScore from '../ContentModScore';

interface CommentModScoreProps {
    commentId: string;
    tokenName: string;
}

export const CommentModScore: FC<CommentModScoreProps> = props => {
    const { commentId, tokenName } = props;

    const comment = useComment(commentId);

    if (!comment || !comment.moderationScore || !comment.moderationContent) return null;
    if (!isPermissioned(tokenName, 'hideContent')) return null;
    if (comment.moderationScore < 75) return null;

    return <ContentModScore moderationContent={comment.moderationContent} moderationScore={comment.moderationScore} />;
};
